import React, { Component } from 'react';
import axios from 'axios';
import Header from '../common/layout/header'; 
import Footer from '../common/layout/footer';
import Loader from '../common/loader';
import { BaseUrl } from '../common/config';

class Categories extends Component {

   constructor(props){
    super(props)
    this.state = {
      loading: true,
      pdflistData: [],
    };

    if(localStorage.getItem("sitemaintanance") == '1'){
        window.location.href = '/sitemaintanance';
    }

   }



    componentDidMount(){

    this.pdflist();
    var timeInterval = '2000';
    this.setState({loading: true});

    var current = this;
    var myInterval = setInterval(function() {
        timeInterval = '';
        current.setState({loading: false});
        clearInterval(myInterval);
      },timeInterval);
    }


    pdflist(){

      this.setState({ loading: true });

      var loginDetails = {};
        if (localStorage.getItem('authData')) {
        loginDetails = JSON.parse(localStorage.getItem('authData'));
        }
          
      let URL = BaseUrl + "/listpdf";

      axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {

       let responseData = response.data.data[0];

       //console.log(responseData, 'responseData');

       this.setState({ pdflistData: responseData});

       });
  
      }


    render(){

        return(
        <>
            <Header/>
            {!this.state.loading &&
                <main className='main-section'>
                <section className="cater-block">
                    <div className="sm-container">

                        <div className="cater-sec">

                           <div className="acc-ttflx">
                                <h1 className="checkout-title">PRODUCTS INFO</h1>
                                <a href='/home' className="acc-back"><i className="fa fa-arrow-left"></i> Back To Main</a>
                            </div>
                            
                            <div className="cater-flx">
                                <div className="cater-item">
                                    <a className="cater-innr" href={BaseUrl +"Allergen_Nutrition_File_SP_April_2023.xlsx"} target='_blank' download={"Allergen_Nutrition_File_SP_April_2023.xlsx"}>
                                        Allergens & Nutritional Info <br />
                                    </a>
                                </div>
                                <div className="cater-item">
                                    <a className="cater-innr" href="/terms">
                                        T&Cs, Privacy Policy,<br /> Legal Documents
                                    </a>
                                </div>
                                <div className="cater-item">

                                {this.state.pdflistData !== '' && this.state.pdflistData !== undefined ? 

                                    <a className="cater-innr" target="_blank"  href={BaseUrl + this.state.pdflistData.path}>
                                    New Products
                                    </a> : <a className="cater-innr"> New Products Coming Soon </a>
                                }

                                </div>
                                <div className="cater-item">
                                    <a className="cater-innr" target="_blank" href="https://tugo.co.uk/our-story">
                                        General Information
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                  
                </section>
              </main>}

                {this.state.loading && <main className='main-section'><Loader propsClassName="load-lag" /> </main>}

            <Footer/>
        </>
        );
    }
}

export default Categories;